// EditUserModal.js
import React, { useState, useEffect } from "react";
import "./admin.css";

const EditUserModal = ({ user, onClose, onUpdateUser }) => {
  const [updatedUser, setUpdatedUser] = useState({
    username: "",
    email: "",
    role: "utilisateur",
    password: "", 
  });


  useEffect(() => {
    if (user) {
      setUpdatedUser({
        username: user.username || "",
        email: user.email || "",
        role: user.role || "utilisateur",
        password: "", 
      });
    }
  }, [user]);

  const handleSave = () => {
    if (!updatedUser.username || !updatedUser.email) {
      alert("Veuillez remplir tous les champs.");
      return;
    }

    onUpdateUser({ ...updatedUser, id: user.id });
  };

  return (
    <div className="modalOverlay">
      <div className="modalContent">
        <h2>Modifier l'utilisateur</h2>

        <label>Nom d'utilisateur</label>
        <input
          type="text"
          value={updatedUser.username}
          onChange={(e) =>
            setUpdatedUser({ ...updatedUser, username: e.target.value })
          }
          placeholder="Entrez le nom"
        />

        <label>Email</label>
        <input
          type="email"
          value={updatedUser.email}
          onChange={(e) =>
            setUpdatedUser({ ...updatedUser, email: e.target.value })
          }
          placeholder="Entrez l'email"
        />

        <label>Mot de passe (laisser vide si inchangé)</label>
        <input
          type="password"
          value={updatedUser.password}
          onChange={(e) =>
            setUpdatedUser({ ...updatedUser, password: e.target.value })
          }
          placeholder="Nouveau mot de passe"
        />

        <label>Rôle</label>
        <select
          value={updatedUser.role}
          onChange={(e) =>
            setUpdatedUser({ ...updatedUser, role: e.target.value })
          }
        >
          <option value="admin">Admin</option>
          <option value="utilisateur">Utilisateur</option>
        </select>

        <div className="modalActions">
          <button className="saveButton" onClick={handleSave}>
            Enregistrer
          </button>
          <button className="cancelButton" onClick={onClose}>
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditUserModal;
